export default __webpack_public_path__ + "static/media/Initiate's Robes of the Crescent.5dd159fe.jpg";